export default "/stake-shell.79ee09d66e20df434b96abc4fa77fa84.png";